var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, BLACK_900, Button, getTestId, GridCol, GridContainer, GridRow, InfoTag, isLastItem, isValidObject, tokens, Typography, useBreakpoint } from '@airtel/air-design-system';
import { useState } from 'react';
import { View } from 'react-native';
import { PackAmountWidget } from '../pack-amount-widget';
import { PackDetailsListItemWidget } from '../pack-details-list-item-widget';
import { getPlanDetailsWidgetStyles } from './PlanDetailsWidgetStyles';
import { AddOnWidget } from '../add-on-widget';
import { getAddOnWidgetStyles } from '../add-on-widget/AddOnWidgetStyles';
import { SectionTitleWidget } from '../section-title-widget';
import { CalloutWidget } from '../callout-widget';
export var PlanDetailsWidgetComponent = props => {
  var id = props.id,
    _props$planInfoData = props.planInfoData,
    planInfoData = _props$planInfoData === void 0 ? {} : _props$planInfoData,
    _props$benefitData = props.benefitData,
    benefitData = _props$benefitData === void 0 ? [] : _props$benefitData,
    _props$ctaText = props.ctaText,
    ctaText = _props$ctaText === void 0 ? '' : _props$ctaText,
    _props$planDetailTitl = props.planDetailTitle,
    planDetailTitle = _props$planDetailTitl === void 0 ? '' : _props$planDetailTitl,
    _props$infoTagText = props.infoTagText,
    infoTagText = _props$infoTagText === void 0 ? '' : _props$infoTagText,
    _props$multiInfoTags = props.multiInfoTags,
    multiInfoTags = _props$multiInfoTags === void 0 ? [] : _props$multiInfoTags,
    infoTagProps = props.infoTagProps,
    _props$viewAllCtaProp = props.viewAllCtaProps,
    viewAllCtaProps = _props$viewAllCtaProp === void 0 ? {} : _props$viewAllCtaProp,
    _props$maxInitialBene = props.maxInitialBenefitToBeShown,
    maxInitialBenefitToBeShown = _props$maxInitialBene === void 0 ? {
      mobile: 5,
      desktop: 10
    } : _props$maxInitialBene,
    _props$benefitsColCou = props.benefitsColCountDesktop,
    benefitsColCountDesktop = _props$benefitsColCou === void 0 ? 2 : _props$benefitsColCou,
    onCtaPress = props.onCtaPress,
    onUserAction = props.onUserAction,
    style = props.style,
    _props$showAddOn = props.showAddOn,
    showAddOn = _props$showAddOn === void 0 ? false : _props$showAddOn,
    _props$addOnList = props.addOnList,
    addOnList = _props$addOnList === void 0 ? [] : _props$addOnList,
    _props$addOnTitle = props.addOnTitle,
    addOnTitle = _props$addOnTitle === void 0 ? '' : _props$addOnTitle,
    _props$hideCtaOnSmall = props.hideCtaOnSmallScreen,
    hideCtaOnSmallScreen = _props$hideCtaOnSmall === void 0 ? false : _props$hideCtaOnSmall,
    detailContainerStyle = props.detailContainerStyle,
    _props$sectionTitleWi = props.sectionTitleWidgetProps,
    sectionTitleWidgetProps = _props$sectionTitleWi === void 0 ? {} : _props$sectionTitleWi,
    _props$calloutWidgetP = props.calloutWidgetProps,
    calloutWidgetProps = _props$calloutWidgetP === void 0 ? {} : _props$calloutWidgetP,
    restProps = __rest(props, ["id", "planInfoData", "benefitData", "ctaText", "planDetailTitle", "infoTagText", "multiInfoTags", "infoTagProps", "viewAllCtaProps", "maxInitialBenefitToBeShown", "benefitsColCountDesktop", "onCtaPress", "onUserAction", "style", "showAddOn", "addOnList", "addOnTitle", "hideCtaOnSmallScreen", "detailContainerStyle", "sectionTitleWidgetProps", "calloutWidgetProps"]);
  var _restProps$testID = restProps.testID,
    testID = _restProps$testID === void 0 ? 'PlanDetailsWidget' : _restProps$testID;
  var onViewAllCtaPress = viewAllCtaProps.onViewAllCtaPress,
    _viewAllCtaProps$expa = viewAllCtaProps.expandedText,
    expandedText = _viewAllCtaProps$expa === void 0 ? 'view less' : _viewAllCtaProps$expa,
    _viewAllCtaProps$coll = viewAllCtaProps.collapsedText,
    collapsedText = _viewAllCtaProps$coll === void 0 ? 'view all' : _viewAllCtaProps$coll;
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen,
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var planDetailsWidgetStyles = getPlanDetailsWidgetStyles(isLargeScreen);
  var _useState = useState(false),
    showFullList = _useState[0],
    setShowFullList = _useState[1];
  var MAX = isSmallScreen ? maxInitialBenefitToBeShown.mobile : maxInitialBenefitToBeShown.desktop;
  var planDetailsData = benefitData.length > MAX ? benefitData.slice(0, MAX + 1) : benefitData;
  var showViewAllCta = benefitData.length > MAX;
  var renderedData = showFullList ? benefitData : planDetailsData;
  var ctaTitle = showFullList ? expandedText : collapsedText;
  var viewMoreIcon = showFullList ? 'UpChevronButtonIcon' : 'DownChevronButtonIcon';
  var addOnWidgetStyles = getAddOnWidgetStyles(props, isLargeScreen);
  var toggleShowFullList = () => {
    setShowFullList(!showFullList);
  };
  var showCta = !!ctaText && (hideCtaOnSmallScreen ? isLargeScreen : true);
  return _jsxs(View, Object.assign({
    style: [!isSmallScreen && planDetailsWidgetStyles.outerContainer, style]
  }, getTestId(testID), restProps, {
    children: [_jsx(PackAmountWidget, Object.assign({}, planInfoData, {
      testID: testID
    })), showAddOn && _jsxs(View, Object.assign({
      style: planDetailsWidgetStyles.addOnWidget
    }, {
      children: [_jsx(Typography, Object.assign({
        text: addOnTitle
      }, getTestId(testID, 'addOnTitle'), {
        type: isSmallScreen ? 'body-single-line-md-bold' : 'body-single-line-lg-bold',
        color: BLACK_900,
        style: planDetailsWidgetStyles.addOnTitle
      })), _jsx(View, Object.assign({
        style: addOnWidgetStyles.wrapper
      }, {
        children: addOnList.map((item, i) => {
          return _jsx(View, Object.assign({
            style: isLastItem(addOnList, i) ? planDetailsWidgetStyles.addOnWidgetItemLast : planDetailsWidgetStyles.addOnWidgetItem
          }, {
            children: _jsx(AddOnWidget, Object.assign({}, getTestId(testID + '_addOnList', i.toString()), item))
          }), i);
        })
      }))]
    })), (multiInfoTags === null || multiInfoTags === void 0 ? void 0 : multiInfoTags.length) > 0 && _jsx(View, Object.assign({
      style: planDetailsWidgetStyles.multiInfoTagsContainer
    }, {
      children: multiInfoTags.map((singleInfoTag, index) => {
        return _jsx(InfoTag, Object.assign({
          size: "md",
          subType: "new"
        }, singleInfoTag, {
          style: [planDetailsWidgetStyles.multiInfoTags, !isLastItem(multiInfoTags, index) && {
            marginRight: tokens.spacing.SPACING_8
          }, singleInfoTag.style]
        }, getTestId(testID, "multiInfoTags_" + index)), "single_info_tag_" + index);
      })
    })), _jsxs(View, Object.assign({
      style: [planDetailsWidgetStyles.container, detailContainerStyle]
    }, {
      children: [!!planDetailTitle && _jsx(Typography, Object.assign({
        text: planDetailTitle,
        type: "title-single-line-md",
        color: BLACK_700,
        style: planDetailsWidgetStyles.plantitle
      }, getTestId(testID, 'planDetailTitle'))), !!infoTagText && _jsx(InfoTag, Object.assign({
        text: infoTagText,
        subType: "offer",
        iconName: "OfferButtonIcon",
        size: "lg",
        style: planDetailsWidgetStyles.infotag
      }, infoTagProps, getTestId(testID, 'tagText'))), isValidObject(sectionTitleWidgetProps) && _jsx(SectionTitleWidget, Object.assign({}, sectionTitleWidgetProps, getTestId(testID, 'sectionTitle'))), isValidObject(calloutWidgetProps) && _jsx(CalloutWidget, Object.assign({}, calloutWidgetProps, getTestId(testID, 'callout'))), _jsx(GridContainer, Object.assign({}, getTestId(testID, 'gridContainer'), {
        noMargin: true
      }, {
        children: _jsxs(GridRow, Object.assign({}, getTestId(testID, 'gridRow'), {
          noMargin: true
        }, {
          children: [renderedData === null || renderedData === void 0 ? void 0 : renderedData.map((item, index) => {
            return _jsx(GridCol, Object.assign({
              breakpoints: {
                xs: 12,
                md: benefitsColCountDesktop == 1 ? 12 : 6
              },
              noGutter: true,
              noTopGutter: true
            }, {
              children: !(showViewAllCta && !showFullList && isLastItem(renderedData, index)) && (_createElement(PackDetailsListItemWidget, Object.assign({}, getTestId(testID + 'packDetailsList', index.toString()), {
                packTitle: item === null || item === void 0 ? void 0 : item.data,
                packSubTitle: item === null || item === void 0 ? void 0 : item.subTitle,
                key: "pack_list_item" + index,
                iconName: item === null || item === void 0 ? void 0 : item.icon,
                hideDivider: true,
                noPadding: true,
                style: [planDetailsWidgetStyles.packDetailListItem, index % 2 === 0 && planDetailsWidgetStyles.paddingRight],
                hideRightChevronIcon: true,
                isPressable: false,
                onUserAction: onUserAction
              }, item)))
            }));
          }), _jsx(GridCol, Object.assign({}, getTestId(testID, 'grid_column'), {
            noGutter: true,
            noTopGutter: true
          }, {
            children: showViewAllCta && _jsx(Button, Object.assign({}, getTestId(testID, 'viewAllCta'), {
              buttonType: "tertiary",
              title: ctaTitle,
              size: isSmallScreen ? 'md' : 'lg',
              iconName: viewMoreIcon,
              iconPosition: "right",
              onPress: () => {
                onViewAllCtaPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
                  id
                }, onViewAllCtaPress), {
                  viewAllCtaProps
                }));
                toggleShowFullList();
              }
            }, viewAllCtaProps))
          }))]
        }))
      }))]
    })), showCta && _jsx(Button, Object.assign({
      title: ctaText,
      size: isSmallScreen ? 'md' : 'lg',
      version: "variable-width",
      onPress: () => {
        onCtaPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onCtaPress), {
          ctaText
        }));
      },
      style: !isSmallScreen && planDetailsWidgetStyles.button
    }, getTestId(testID, 'ctaText')))]
  }));
};
PlanDetailsWidgetComponent.genericRendererKey = 'AirPlanDetailsWidget';